import { Injectable } from '@angular/core';
import { GenericService } from '../generic.service';
import { Observable } from 'rxjs';
import { apiResponse } from '../../models/apiResponse';
import { ListMindlerAssessmentReportResponse } from '../../models/reporting/listMindlerAssessmentReportResponse';
import { ListMindlerAssessmentReportRequest } from '../../models/reporting/listMindlerAssessmentReportRequest';
import {  HttpResponse } from '@angular/common/http';
import { PendingStudentsSyncStatusResponse, ProcessStudentsBatchRequest } from '../../models/reporting/pending-students-sync-status.model';

@Injectable({
  providedIn: 'root'
})
export class ReportingService {

  constructor(private genericService: GenericService) { }

  listMindlerAssessmentReport(req: ListMindlerAssessmentReportRequest):Observable<apiResponse<ListMindlerAssessmentReportResponse[]>>
  {
    return this.genericService.post(`mindler/assessment-report`,req);
  }
  downloadAssessmentReport(req: ListMindlerAssessmentReportRequest): Observable<HttpResponse<ArrayBuffer>>
  {
    return this.genericService.getBinaryPost(`download/assessment-Report`, req);
  }

  /** Academic sessions that have tests, newest first (school admins only get their own school's). */
  listAcademicSessions(): Observable<apiResponse<string[]>> {
    return this.genericService.get(`mindler/sessions`);
  }

  getPendingStudentsSyncStatus(): Observable<PendingStudentsSyncStatusResponse> {
    return this.genericService.get(`mindler/pending-students-sync-status`);
  }

  processStudentsBatch(request: ProcessStudentsBatchRequest): Observable<any> {
    return this.genericService.post(`mindler/process-students-batch`, request);
  }
}